<template>
    <b-modal id="edit-modal" size="lg" title="Edit Package">
        <div id="edit-package" class="modal-form">
            <b-row no-gutters>
                <b-col sm="12" md="3">
                    <h6 class="main-label">Name</h6>
                </b-col>
                <b-col>
                    <b-form-group id="nameGroup"
                        label="Package Name"
                        label-for="name" 
                        class="secondary-label mb-2"
                        :invalid-feedback="errorMessage('name')"
                        :state="isValid('name')">
                        <b-form-input id="name"
                            type="text"
                            v-model="form.name"
                            required
                            maxlength="25">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        label="Select Category"
                        label-for="category_id"
                        class="secondary-label mb-2"
                        :invalit-feedback="errorMessage('category_id')"
                        :state="isValid('category_id')">
                        <b-form-select id="category" v-model="form.category_id">
                            <option v-for="(category, index) in categories" :value="category.id" :key="index">
                                {{ category.name }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <hr class="form-divider">
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col sm="12" md="3">
                    <h6 class="main-label">Image</h6>
                    <span class="label-helper d-inline-block">(350 x 200)</span>
                </b-col>
                <b-col>
                    <b-form-group :invalid-feedback="errorMessage('image')"
                                  :state="isValid('image')"
                    >
                        <div id="class-upload-image" class="border" v-b-modal.packageUploadImage>
                            <!-- Use an if else here for showing an image -->
                            <img v-if="image === ''" :src="form.image" alt="Package Image">
                            <img v-else :src="image" alt="Package Image">
                            <div class="upload-icon rounded-circle border">
                            </div>
                        </div>
                    </b-form-group>                    
                </b-col>
            </b-row>
            <b-row class="mt-2 mb-2">
                <b-col>
                    <hr class="form-divider">
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <h6 class="main-label">Description</h6>
                </b-col>
                <b-col>
                    <b-form-group 
                        id="descriptionGroup"
                        :label="descriptionLabel"
                        label-for="description"
                        class="secondary-label mb-2"
                        :invalid-feedback="errorMessage('description')"
                        :state="isValid('description')"
                    >
                        <b-form-textarea id="description"
                                         v-model="form.description"
                                         placeholder="Enter description"
                                         :rows="3"
                                         :maxlength="descriptionMaxLength"
                                         :max-rows="6">
                        </b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <hr class="form-divider">
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <h6 class="main-label">Logo Stamp</h6>
                    <span class="label-helper">(200x200)</span>
                </b-col>
                <b-col>
                    <b-form-group :invalid-feedback="errorMessage('logo_stamp')"
                                  :state="isValid('logo_stamp')"
                    >
                        <div id="logo-stamp-upload-image" class="border rounded-circle" v-b-modal.packageUploadLogoStamp>
                            <!-- Use an if else here for showing an image -->
                            <img v-if="logoStamp === ''" :src="form.logo_stamp" alt="Logo Stamp">
                            <img v-else :src="logoStamp" alt="Logo Stamp">
                            <div class="upload-icon rounded-circle border">
                            </div>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <hr class="form-divider">
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <h6 class="main-label">Validity</h6>
                </b-col>
                <b-col>
                    <b-row>
                        <b-col cols="4">
                            <b-form-group
                                id="durationGroup"
                                label="Duration"
                                label-for="duration"
                                class="secondary-label"
                                :invalid-feedback="errorMessage('duration')"
                                :state="isValid('duration')"
                            >
                                <b-form-input id="duration" type="number" v-model="form.duration" required min="1" oninput="this.value = Math.abs(this.value)"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col class="pl-0">
                            <b-form-group
                                id="daysGroup"
                                label-for="days"
                                class="secondary-label validity-unit"
                                :invalid-feedback="errorMessage('duration_type')"
                                :state="isValid('duration_type')"
                            >
                                <b-form-select v-model="form.duration_type" :options="durationTypeOptions" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <hr class="form-divider">
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <h6 class="main-label">Number of Visits</h6>
                </b-col>
                <b-col>
                    <b-row>
                        <b-col cols="4">
                            <b-form-group
                                id="numberOfVisitsGroup"
                                label="Number of Visits"
                                label-for="numberOfVisits"
                                class="secondary-label"
                                :invalid-feedback="errorMessage('no_of_visits')"
                                :state="isValid('no_of_visits')"
                            >
                                <b-form-input id="numberOfVisits" type="number" v-model="form.no_of_visits" min="1" oninput="this.value = Math.abs(this.value)"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <hr class="form-divider">
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <h6 class="main-label">Price</h6>
                </b-col>
                <b-col>
                    <b-row>
                        <b-col cols="4">
                            <b-form-group
                                id="priceGroup"
                                label="Price"
                                label-for="price"
                                class="secondary-label"
                                :invalid-feedback="errorMessage('price')"
                                :state="isValid('price')"
                            >
                                <b-form-input id="price" type="number" v-model="form.price" min="0" oninput="this.value = Math.abs(this.value)"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                id="maxPurchase"
                                label="Max. Purchase"
                                label-for="max_purchase"
                                class="secondary-label"
                                :invalid-feedback="errorMessage('max_purchase')"
                                :state="isValid('max_purchase')"
                            >
                                <b-form-input id="max_purchase" type="number" v-model="form.max_purchase" min="0" :formatter="capacityFormatter" oninput="this.value = Math.abs(this.value)"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <hr class="form-divider">
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <h6 class="main-label">Visibility</h6>
                </b-col>
                <b-col>
                    <div>
                        <switches v-model="form.visibility" 
                                theme="custom"
                                color="primary"
                                type-bold="true"
                                text-enabled="On"
                                text-disabled="Off"
                                style="top: -18px;">
                        </switches>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div slot="modal-footer">
            <b-button variant="ghost" v-bind:disabled="loading" class="btn-cancel" style="margin-right: .25rem;" @click="clearFields">
                Cancel
            </b-button>
            <b-button variant="primary" v-bind:disabled="loading" style="margin-left: .25rem;" @click="sendForm">
                <template v-if="loading">
                    Saving...
                </template>
                <template v-else>
                    Save
                </template>
            </b-button>
        </div>
    </b-modal>
</template>
<script>
import { mapState } from "vuex";
import Switches from "vue-switches";

function initialState() {
    return {
        form: {
            name: "",
            description: "",
            image: "",
            noOfVisits: "",
            duration: "",
            durationType: "weeks",
            price: "",
            visibility: false,
            logoStamp: "",
            category_id: 0,
            max_purchase: null
        }
    };
}

export default {
    name: "addPackage",
    props: ["image", "logoStamp", "form"],
    data() {
        return {
            descriptionMaxLength: 350,
            durationTypeOptions: [
                { value: "Day", text: "Days" },
                { value: "Week", text: "Weeks" },
                { value: "Month", text: "Months" },
                { value: "Year", text: "Years" }
            ]
        };
    },
    computed: {
        ...mapState("packages", ["loading", "packages", "errors", "categories"]),
        descriptionLabel: {
            get: function() {
                if (this.form.description != null) {
                    return (
                        this.form.description.length +
                        " / " +
                        this.descriptionMaxLength
                    );
                }
                return "0 / " + this.descriptionMaxLength;
            }
        }
    },
    components: {
        Switches
    },
    methods: {
        async getPackages(page) {
            let param = {
                page: page,
                payload: this.searchPayload
            };
            await this.$store.dispatch("packages/getPackages", param);
        },
        async sendForm() {
            this.$store.dispatch("packages/resetErrors");

            let data = {
                uuid: this.form.uuid,
                param: {
                    name: this.form.name,
                    description: this.form.description,
                    no_of_visits: this.form.no_of_visits,
                    duration: this.form.duration,
                    duration_type: this.form.duration_type,
                    price: this.form.price,
                    visibility: this.form.visibility,
                    category_id: this.form.category_id,
                    max_purchase: this.form.max_purchase
                }
            };

            if (this.image !== "") {
                data.param.image = this.image.replace(
                    /^data:image\/\w+;base64,/,
                    ""
                );
            }
            if (this.logoStamp !== "") {
                data.param.logo_stamp = this.logoStamp.replace(
                    /^data:image\/\w+;base64,/,
                    ""
                );
            }

            let _this = this;
            // console.log(data);
            await this.$store
                .dispatch("packages/updatePackage", data)
                .then(function() {
                    if (_this.errors == null) {
                        _this.clearFields();
                        _this.hideModal("edit-modal");
                        _this.getPackages(1);
                    }
                });
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
        clearFields() {
            this.hideModal("edit-modal");
            this.$store.dispatch("packages/resetErrors");

            this.$emit("clearImage", true);
            this.$emit("clearImageLogoStamp", true);
        },
        showModal(modal) {
            this.$root.$emit("bv::show::modal", modal);
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        capacityFormatter(value, event) {
            return event === null
                ? value
                : value.replace(/\./gi, "").substring(0, 3);
        }
    }
};
</script>
<style lang="scss">
</style>
